import { AnyAction } from 'redux';
import {
  GlobalActions,
  StreckenTarifierungRequestEvents,
} from '@ps20-frontend/shop-integration-redux';
import {
  ownPricingErrorReducer,
  OwnPricingEvents,
  vorvertragVorschaedenErmitteltReducer,
} from '@ps20-frontend/reducers';
import {
  App,
  BaseTransientState,
  FeatureToggles,
  Regexps,
  Rolle,
  VorvertragVorschaedenState,
} from '@ps20-frontend/frontend-models';
import { Role } from '@ps20/bff-models';
import { TkvActions } from '../tkvActions';
import { IAppState } from '../appState';

export interface TransientState extends BaseTransientState, VorvertragVorschaedenState, Rolle {}

const ownPricingEvents: OwnPricingEvents = {
  failed: StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_TKV,
  successful: [
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV,
    StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV,
  ],
};

export const transientStateReducer = function (
  sectionState: TransientState = null,
  action: AnyAction,
  appState: IAppState,
): TransientState {
  switch (action.type) {
    case TkvActions.ZURUECK_ZUM_SHOP_MODAL_OPEN: {
      return { ...sectionState, zurueckZumShopModalOpen: true };
    }
    case TkvActions.ZURUECK_ZUM_SHOP_MODAL_CLOSE: {
      return { ...sectionState, zurueckZumShopModalOpen: false };
    }
    case GlobalActions.ROLE_DETERMINED: {
      const role: Role = action.payload.role;
      return { ...sectionState, role };
    }
    case GlobalActions.TARIFIERUNG_HAS_STARTED: {
      return { ...sectionState, tarifierungIsInProgress: true };
    }
    case GlobalActions.TARIFIERUNG_HAS_ENDED: {
      return { ...sectionState, tarifierungIsInProgress: false };
    }
    case GlobalActions.DO_REQUEST:
    case StreckenTarifierungRequestEvents.PREISE_REQUESTED_FAILED_TKV:
    case StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_MIT_INFO_TKV:
    case StreckenTarifierungRequestEvents.PREISE_REQUESTED_SUCCESSFUL_OHNE_INFO_TKV:
      return ownPricingErrorReducer(
        sectionState,
        action,
        { appId: App.TKV, angebotsId: appState?.angebotsId },
        ownPricingEvents,
      );
    case GlobalActions.SET_PRICE_GUARANTEE: {
      return { ...sectionState, priceGuarantee: action.payload };
    }
    case GlobalActions.CHANGE_RELEVANT_RISKDATA_HASH: {
      return {
        ...sectionState,
        priceGuarantee: false,
      };
    }
    case GlobalActions.VORVERTRAG_VORSCHAEDEN_ERMITTELT: {
      return vorvertragVorschaedenErmitteltReducer(sectionState, action, {
        appId: App.TKV,
        angebotsId: appState?.angebotsId,
      });
    }
    case GlobalActions.FEATURE_TOGGLE_RECEIVED: {
      const actionPayload: FeatureToggles = action.payload;
      return { ...sectionState, featureToggles: actionPayload };
    }
    case GlobalActions.REGEXPS_RECEIVED: {
      const actionPayload: Regexps = action.payload;
      return { ...sectionState, regexps: actionPayload };
    }
    case GlobalActions.SETTINGS_RECEIVED:
      return {
        ...sectionState,
        settings: action.payload,
      };
    case GlobalActions.KOOPERATIONEN_LIST_RECEIVED: {
      return {
        ...sectionState,
        kooperationen: action.payload,
      };
    }
    default:
      return sectionState;
  }
};
